"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Controls = exports.X_PADDING = exports.X_SPACER = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var remotion_1 = require("remotion");

var format_time_1 = require("./format-time");

var icons_1 = require("./icons");

var MediaVolumeSlider_1 = require("./MediaVolumeSlider");

var PlayerSeekBar_1 = require("./PlayerSeekBar");

var use_video_controls_resize_1 = require("./use-video-controls-resize");

exports.X_SPACER = 10;
exports.X_PADDING = 12;
var containerStyle = {
  boxSizing: 'border-box',
  position: 'absolute',
  bottom: 0,
  width: '100%',
  paddingTop: 10,
  paddingBottom: 10,
  background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.4))',
  display: 'flex',
  paddingRight: exports.X_PADDING,
  paddingLeft: exports.X_PADDING,
  flexDirection: 'column',
  transition: 'opacity 0.3s'
};
var buttonStyle = {
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  display: 'inline',
  marginBottom: 0,
  marginTop: 0,
  height: 25
};
var controlsRow = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none'
};
var leftPartStyle = {
  display: 'flex',
  flexDirection: 'row',
  userSelect: 'none',
  alignItems: 'center'
};
var xSpacer = {
  width: 10
};
var ySpacer = {
  height: 8
};
var flex1 = {
  flex: 1
};
var fullscreen = {};

var PlayPauseButton = function PlayPauseButton(_ref) {
  var playing = _ref.playing;
  return playing ? (0, jsx_runtime_1.jsx)(icons_1.PauseIcon, {}) : (0, jsx_runtime_1.jsx)(icons_1.PlayIcon, {});
};

var Controls = function Controls(_ref2) {
  var durationInFrames = _ref2.durationInFrames,
      hovered = _ref2.hovered,
      isFullscreen = _ref2.isFullscreen,
      fps = _ref2.fps,
      player = _ref2.player,
      showVolumeControls = _ref2.showVolumeControls,
      onFullscreenButtonClick = _ref2.onFullscreenButtonClick,
      allowFullscreen = _ref2.allowFullscreen,
      onExitFullscreenButtonClick = _ref2.onExitFullscreenButtonClick,
      spaceKeyToPlayOrPause = _ref2.spaceKeyToPlayOrPause,
      onSeekEnd = _ref2.onSeekEnd,
      onSeekStart = _ref2.onSeekStart,
      inFrame = _ref2.inFrame,
      outFrame = _ref2.outFrame,
      initiallyShowControls = _ref2.initiallyShowControls,
      playerWidth = _ref2.playerWidth,
      renderPlayPauseButton = _ref2.renderPlayPauseButton,
      renderFullscreenButton = _ref2.renderFullscreenButton;
  var playButtonRef = (0, react_1.useRef)(null);
  var frame = remotion_1.Internals.Timeline.useTimelinePosition();

  var _ref3 = (0, react_1.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      supportsFullscreen = _ref4[0],
      setSupportsFullscreen = _ref4[1];

  var _ref5 = (0, use_video_controls_resize_1.useVideoControlsResize)({
    allowFullscreen: allowFullscreen,
    playerWidth: playerWidth
  }),
      maxTimeLabelWidth = _ref5.maxTimeLabelWidth,
      displayVerticalVolumeSlider = _ref5.displayVerticalVolumeSlider;

  var _ref6 = (0, react_1.useState)(function () {
    if (typeof initiallyShowControls === 'boolean') {
      return initiallyShowControls;
    }

    if (typeof initiallyShowControls === 'number') {
      if (initiallyShowControls % 1 !== 0) {
        throw new Error('initiallyShowControls must be an integer or a boolean');
      }

      if (Number.isNaN(initiallyShowControls)) {
        throw new Error('initiallyShowControls must not be NaN');
      }

      if (!Number.isFinite(initiallyShowControls)) {
        throw new Error('initiallyShowControls must be finite');
      }

      if (initiallyShowControls <= 0) {
        throw new Error('initiallyShowControls must be a positive integer');
      }

      return initiallyShowControls;
    }

    throw new TypeError('initiallyShowControls must be a number or a boolean');
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      shouldShowInitially = _ref7[0],
      setInitiallyShowControls = _ref7[1];

  var containerCss = (0, react_1.useMemo)(function () {
    // Hide if playing and mouse outside
    var shouldShow = hovered || !player.playing || shouldShowInitially;
    return _objectSpread(_objectSpread({}, containerStyle), {}, {
      opacity: Number(shouldShow)
    });
  }, [hovered, shouldShowInitially, player.playing]);
  (0, react_1.useEffect)(function () {
    if (playButtonRef.current && spaceKeyToPlayOrPause) {
      // This switches focus to play button when player.playing flag changes
      playButtonRef.current.focus({
        preventScroll: true
      });
    }
  }, [player.playing, spaceKeyToPlayOrPause]);
  (0, react_1.useEffect)(function () {
    var _a; // Must be handled client-side to avoid SSR hydration mismatch


    setSupportsFullscreen((_a = typeof document !== 'undefined' && (document.fullscreenEnabled || document.webkitFullscreenEnabled)) !== null && _a !== void 0 ? _a : false);
  }, []);
  (0, react_1.useEffect)(function () {
    if (shouldShowInitially === false) {
      return;
    }

    var time = shouldShowInitially === true ? 2000 : shouldShowInitially;
    var timeout = setTimeout(function () {
      setInitiallyShowControls(false);
    }, time);
    return function () {
      clearInterval(timeout);
    };
  }, [shouldShowInitially]);
  var timeLabel = (0, react_1.useMemo)(function () {
    return {
      color: 'white',
      fontFamily: 'sans-serif',
      fontSize: 14,
      maxWidth: maxTimeLabelWidth,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    };
  }, [maxTimeLabelWidth]);
  return (0, jsx_runtime_1.jsxs)("div", {
    style: containerCss,
    children: [(0, jsx_runtime_1.jsxs)("div", {
      style: controlsRow,
      children: [(0, jsx_runtime_1.jsxs)("div", {
        style: leftPartStyle,
        children: [(0, jsx_runtime_1.jsx)("button", {
          ref: playButtonRef,
          type: "button",
          style: buttonStyle,
          onClick: player.playing ? player.pause : player.play,
          "aria-label": player.playing ? 'Pause video' : 'Play video',
          title: player.playing ? 'Pause video' : 'Play video',
          children: renderPlayPauseButton === null ? (0, jsx_runtime_1.jsx)(PlayPauseButton, {
            playing: player.playing
          }) : renderPlayPauseButton({
            playing: player.playing
          })
        }), showVolumeControls ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
          children: [(0, jsx_runtime_1.jsx)("div", {
            style: xSpacer
          }), (0, jsx_runtime_1.jsx)(MediaVolumeSlider_1.MediaVolumeSlider, {
            displayVerticalVolumeSlider: displayVerticalVolumeSlider
          })]
        }) : null, (0, jsx_runtime_1.jsx)("div", {
          style: xSpacer
        }), (0, jsx_runtime_1.jsxs)("div", {
          style: timeLabel,
          children: [(0, format_time_1.formatTime)(frame / fps), " / ", (0, format_time_1.formatTime)(durationInFrames / fps)]
        }), (0, jsx_runtime_1.jsx)("div", {
          style: xSpacer
        })]
      }), (0, jsx_runtime_1.jsx)("div", {
        style: flex1
      }), (0, jsx_runtime_1.jsx)("div", {
        style: fullscreen,
        children: supportsFullscreen && allowFullscreen ? (0, jsx_runtime_1.jsx)("button", {
          type: "button",
          "aria-label": isFullscreen ? 'Exit fullscreen' : 'Enter Fullscreen',
          title: isFullscreen ? 'Exit fullscreen' : 'Enter Fullscreen',
          style: buttonStyle,
          onClick: isFullscreen ? onExitFullscreenButtonClick : onFullscreenButtonClick,
          children: renderFullscreenButton === null ? (0, jsx_runtime_1.jsx)(icons_1.FullscreenIcon, {
            isFullscreen: isFullscreen
          }) : renderFullscreenButton({
            isFullscreen: isFullscreen
          })
        }) : null
      })]
    }), (0, jsx_runtime_1.jsx)("div", {
      style: ySpacer
    }), (0, jsx_runtime_1.jsx)(PlayerSeekBar_1.PlayerSeekBar, {
      onSeekEnd: onSeekEnd,
      onSeekStart: onSeekStart,
      durationInFrames: durationInFrames,
      inFrame: inFrame,
      outFrame: outFrame
    })]
  });
};

exports.Controls = Controls;